import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { baseURL, SETTINGS } from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileAlt, faPhoneAlt, faListOl, faImage } from "@fortawesome/free-solid-svg-icons";

export default function Setting() {
  const axiosPrivate = useAxiosPrivate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    payment_number: "",
    admin_instapay: "",
    support_phone: "",
    instructions: "",
    invoice_discount: "0",
    invoice_total_override: "",
    platform_teacher_image: null,
    platform_teacher_image_url: "",
  });

  useEffect(() => {
    async function fetchSettings() {
      setLoading(true);
      try {
        const response = await axiosPrivate.get(`${baseURL}/${SETTINGS}`);
        const settings = response.data?.data || {};
        setData({
          payment_number: settings.payment_number || "",
          admin_instapay: settings.admin_instapay || "",
          support_phone: settings.support_phone || "",
          instructions: settings.instructions || "",
          invoice_discount: settings.invoice_discount || "0",
          invoice_total_override: settings.invoice_total_override || "",
          platform_teacher_image: null,
          platform_teacher_image_url: settings.platform_teacher_image || "",
        });
      } catch (error) {
        console.error("Error fetching settings:", error);
        toast.error("فشل تحميل الإعدادات");
      } finally {
        setLoading(false);
      }
    }
    fetchSettings();
  }, [axiosPrivate]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setData((prev) => ({ ...prev, [name]: files[0] || null }));
      return;
    }
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (key === "platform_teacher_image_url") return;
        if (value !== null && value !== undefined) formData.append(key, value);
      });
      await axiosPrivate.post(`${baseURL}/${SETTINGS}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("تم حفظ إعدادات الفاتورة بنجاح");
    } catch (error) {
      console.error("Error saving settings:", error);
      toast.error("حدث خطأ أثناء حفظ الإعدادات، حاول مرة أخرى.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Lodingsubmit />}
      <ToastContainer position="top-center" reverseOrder={false} />

      <div className="p-4 content" dir="rtl">
        <h2 className="fw-bold mb-5">إعدادات الفاتورة والمنصة</h2>
        <div className="d-flex align-items-center">
          <Form className="Form w-75" onSubmit={handleSubmit}>
            
            {/* رقم فودافون كاش */}
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="payment_number"
                value={data.payment_number}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faMobileAlt} />
                <span className="textinpout">رقم فودافون كاش للأدمن الأساسي</span>
              </Form.Label>
            </Form.Group>

            {/* حساب انستا باي للادمن */}
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="admin_instapay"
                value={data.admin_instapay}
                onChange={handleChange}
                placeholder=" "
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faMobileAlt} />
                <span className="textinpout">حساب انستا باي (InstaPay Address) للأدمن الأساسي</span>
              </Form.Label>
            </Form.Group>

            {/* رقم الدعم الفني */}
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="support_phone"
                value={data.support_phone}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faPhoneAlt} />
                <span className="textinpout">رقم تيم الدعم الفني (واتساب / تليجرام / اتصال)</span>
              </Form.Label>
            </Form.Group>

            {/* خطوات إتمام عملية الاشتراك */}
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                as="textarea"
                rows={6}
                className="inpoutFeald"
                name="instructions"
                value={data.instructions}
                onChange={handleChange}
                placeholder=" "
                style={{ height: "auto", paddingTop: "25px" }}
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faListOl} />
                <span className="textinpout">خطوات الدفع والاشتراك (إذا كانت فارغة، سيتم عرض الخطوات الافتراضية)</span>
              </Form.Label>
              <Form.Text className="text-muted">
                اكتب كل خطوة في سطر منفصل ليتم عرضها كقائمة مرقمة على صفحة الفاتورة.
              </Form.Text>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                min="0"
                step="0.01"
                name="invoice_discount"
                value={data.invoice_discount}
                onChange={handleChange}
                placeholder=" "
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faListOl} />
                <span className="textinpout">الخصم على الفاتورة (جنيه)</span>
              </Form.Label>
              <Form.Text className="text-muted">
                اتركها صفر إذا لم يكن هناك خصم عام على الفواتير.
              </Form.Text>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                min="0"
                step="0.01"
                name="invoice_total_override"
                value={data.invoice_total_override}
                onChange={handleChange}
                placeholder=" "
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faListOl} />
                <span className="textinpout">المبلغ النهائي للفاتورة (اختياري)</span>
              </Form.Label>
              <Form.Text className="text-muted">
                يُحسب المبلغ تلقائياً من السعر والخصم إذا تركته فارغاً.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-5">
              <Form.Label className="fw-bold d-flex align-items-center gap-2">
                <FontAwesomeIcon className="iconeForm" icon={faImage} />
                <span>صورة كارت مدرس المنصة</span>
              </Form.Label>
              {data.platform_teacher_image_url && (
                <div className="mb-3">
                  <img
                    src={data.platform_teacher_image_url}
                    alt="صورة مدرس المنصة"
                    style={{ width: 160, height: 120, objectFit: "cover", borderRadius: 8, border: "1px solid #ddd" }}
                  />
                </div>
              )}
              <Form.Control
                className="inpoutFeald"
                type="file"
                name="platform_teacher_image"
                accept="image/*"
                onChange={handleChange}
              />
              <Form.Text className="text-muted">
                الصورة دي بتظهر في كارت أ / محمود الصبروط على المنصة.
              </Form.Text>
            </Form.Group>
            <Button type="submit" className="custom-brand-btn-dhash px-5 py-2">
              حفظ الإعدادات
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
}
